import React from 'react';
import { useSelector } from 'react-redux';
import { EventTrackingActions } from '@carvana/purchase-utils';
import { CartHeartIcon } from '@carvana/purchase-icons';
import { DashboardModalActions } from '@carvana/purchase-helpers';
import { RouteToAppStore } from '../../../ducks/actions';
import * as sc from './mobile-web-to-mobile-app-modal.styles';

const MobileWebToMobileAppModal = () => {
  const { os } = useSelector(state => state?.ui?.browser);
  const isIOS = os === 'iOS';
  const iOSMessage = 'Download from the Apple App Store';
  const androidMessage = 'Download from the Android Play Store';

  const buttonMessage = isIOS ? iOSMessage : androidMessage;
  const declineMessage = 'No thanks, continue on Carvana.com';

  const trackToAppStore = () => {
    EventTrackingActions.TrackEvent({
      name: 'Clicked native app offering modal'
    });
  };

  const trackDeclineToAppStore = () => {
    EventTrackingActions.TrackEvent({
      name: 'Closed native app offering modal'
    });
  };

  return (
    <sc.Container>
      <sc.LeftJustifiedContent>
        <sc.IconWrapper>
          <sc.CartHeartIconWrapper src={CartHeartIcon} />
        </sc.IconWrapper>
        <sc.HeadingContainer>
          <sc.Heading>Check out faster on our mobile app!</sc.Heading>
          <sc.SubHeading>
            Our built in document capture will make upload a breeze; it could
            even help you skip steps!
          </sc.SubHeading>
        </sc.HeadingContainer>

        <sc.BodyContainer>
          <sc.BodyHeading>Enjoy these features:</sc.BodyHeading>
          <sc.FeatureList>
            <sc.FeatureListItem>
              Get up to the minute notifications about your order
            </sc.FeatureListItem>
            <sc.FeatureListItem>
              Skip steps by scanning and uploading your documents
            </sc.FeatureListItem>
            <sc.FeatureListItem>
              Track your delivery or get directions to our vending machines
            </sc.FeatureListItem>
          </sc.FeatureList>
        </sc.BodyContainer>

        <sc.ButtonsContainer>
          <sc.ButtonCheck
            onClick={() => {
              RouteToAppStore(isIOS);
              trackToAppStore();
            }}
          >
            {buttonMessage}
          </sc.ButtonCheck>
        </sc.ButtonsContainer>

        <sc.Decline
          onClick={() => {
            DashboardModalActions.CloseModal();
            trackDeclineToAppStore();
          }}
        >
          {declineMessage}
        </sc.Decline>
      </sc.LeftJustifiedContent>
    </sc.Container>
  );
};

export default MobileWebToMobileAppModal;
